import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRequestData } from 'ws-scripts/modules/common';

import { setHasData } from '../actions/hasdata';
import { setPersonalized } from '../actions/personalized';
import { setAccount } from '../actions/account';

const usePrePromos = () => {
	const dispatch = useDispatch();
	const { windowId } = useRequestData();
	const [prePromos, setPrePromos] = useState({
		promos: [],
		isLoading: true
	});

	useEffect(() => {
		const fetchData = async () => {
			const promoJson = await window.DDC.WidgetData['ws-specials'][
				windowId
			].preloadedPromos;
			const { promos, personalized, accountInfo } = promoJson;

			setPrePromos({
				promos,
				isLoading: false
			});
			dispatch(setPersonalized(personalized));
			dispatch(setHasData(true));
			dispatch(setAccount(accountInfo));
		};
		fetchData();
		/* eslint-disable react-hooks/exhaustive-deps */
	}, []);

	return [prePromos];
};

export { usePrePromos };
